import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none",
  viewBox: "10 7 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.917 8.958a1.5 1.5 0 0 0-1.5-1.5H12.25a1.5 1.5 0 0 0-1.5 1.5v1.375a1.5 1.5 0 0 0 1.5 1.5h5.167a1.5 1.5 0 0 0 1.5-1.5z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M18.924 9.5h1.118a1.5 1.5 0 0 1 1.5 1.5v1.877a1.5 1.5 0 0 1-1.308 1.488l-4.384.566a1.5 1.5 0 0 0-1.308 1.488v2.123"
    }, null, -1)
  ]))]))
}
export default { render: render }